import { createSelector } from 'reselect';

const selectStatusMap = state => state.solicitacoes.statusById;

// Função que retorna um selector dinâmico por ID
export const selectStatusById = (idSolicitacao) => createSelector(
  [selectStatusMap],
  (statusById) => statusById[idSolicitacao]
);
